/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { SearchFiltersSchema } from './searchFiltersSchema';
import type { SearchRequestSchemaSortBy } from './searchRequestSchemaSortBy';

export interface SearchRequestSchema {
  filters?: SearchFiltersSchema | null;
  sort_by?: SearchRequestSchemaSortBy;
  /** @minimum 1 */
  page?: number;
  /**
     * @minimum 1
     * @maximum 100
     */
  per_page?: number;
  include_aggregations?: boolean;
  name?: string | null;
  similar_profile_ids?: string[] | null;
  pool_ids?: string[] | null;
}
